export default function OrganisationManagerPermissionsProvider() {
  this.$get = ($auth, $routeParams) => {
    'ngInject';

    function OrganisationManagerPermissionsProvider() {

      const self = this;

      self.hasPermission = (permission, callback) => $auth.currentUser(() => {
        if (!$auth.isBikeOrganisationOwner()) {
          callback(false);
          return;
        }

        const organisations = $auth.user().organisations;
        if (!organisations || !organisations.find(org => org.id === $routeParams.orgId)) {
          callback(false);
          return;
        }

        let currentOrganisation = organisations.find(org => org.id === $routeParams.orgId);
        if (currentOrganisation.status !== 'ACTIVE') {
          callback(false);
          return;
        }

        const currentPermission = currentOrganisation.role;
        let permit;

        if (currentPermission === 'ACCOUNT_MANAGER' || permission === 'VIEWER') {
          permit = true;
        } else if (currentPermission === permission && permission === 'MANAGER') {
          permit = true;
        } else {
          permit = false;
        }

        callback(permit)
      })
    }

    return new OrganisationManagerPermissionsProvider();
  };
}